export function normalizeFreemiumStatus(raw) {
  const data = raw?.freemium ?? raw?.data?.freemium ?? raw ?? {};
  const unlimited = Boolean(data.unlimited);
  const needsCarePass =
    data.needsCarePass != null ? Boolean(data.needsCarePass) : !unlimited;
  return {
    unlimited,
    needsCarePass,
    profileViewsUsed: Number(data.profileViewsUsed) || 0,
    profileViewsLimit: Number(data.profileViewsLimit) || 10,
    profileViewsRemaining: Number(data.profileViewsRemaining) || 0,
    callsUsed: Number(data.callsUsed) || 0,
    callsLimit: Number(data.callsLimit) || 3,
    callsRemaining: Number(data.callsRemaining) || 0,
    callMaxMinutes: Number(data.callMaxMinutes) || 5,
    /** True when contact/hire need a Care Pass (no active paid pass). */
    paywallRequired: data.paywallRequired != null ? Boolean(data.paywallRequired) : needsCarePass,
    profileLimitReached: Boolean(data.profileLimitReached),
    callLimitReached: Boolean(data.callLimitReached),
    planAmountInr: Number(data.planAmountInr) || 3000,
    planValidityDays: Number(data.planValidityDays) || 90,
    marketplaceAccessPlan: data.marketplaceAccessPlan || null,
  };
}

export function isInsufficientTalkBalanceError(err) {
  const code = String(err?.code || err?.body?.code || "").toUpperCase();
  if (code === "INSUFFICIENT_TALK_BALANCE") return true;
  if (Number(err?.status) !== 402) return false;
  return /call credit|talk (wallet|balance|time)|recharge/i.test(String(err?.message || ""));
}

export function isFreemiumPaywallError(err) {
  if (isInsufficientTalkBalanceError(err)) return false;
  const code = err?.code;
  return (
    code === "CARE_PASS_REQUIRED" ||
    code === "FREEMIUM_PAYWALL" ||
    err?.status === 402 ||
    String(err?.message || "").toLowerCase().includes("care pass") ||
    String(err?.message || "").toLowerCase().includes("free access limit")
  );
}

export function freemiumFromError(err) {
  return normalizeFreemiumStatus(err?.freemium || err?.data?.freemium || {});
}
